<template>
    <div>
        <form @submit.prevent="onSubmit"
              @keydown="errors.clear($event.target.name)">
            <div class="w-full flex">
                <div class="modal-form-block">
                    <label>
                        {{ trans.get('production.date' )}}:
                    </label>
                    <div class="relative">
                        <date-picker class="w-full"
                                     v-model="data_immissione"
                                     name="data_immissione"
                                     :options="{firstDay: 1}"
                        >
                        </date-picker>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-700">
                            <i class="far fa-calendar-alt"></i>
                        </div>
                    </div>
                </div>
                <div class="modal-form-block">
                    <label>
                        {{ trans.get('production.code') }}:
                    </label>
                    <div>
                        <input type="text"
                               name="codice"
                               id="codice"
                               v-model="form.codice"
                               class="w-full">
                    </div>
                    <span class="alert alert-danger"
                          v-if="errors.has('codice')"
                          v-text="errors.get('codice')">
                    </span>
                </div>
            </div>

            <div class="w-full modal-form-block">
                <label>
                    {{ trans.get('production.title' )}}:
                </label>
                <input type="text"
                       name="titolo"
                       id="titolo"
                       v-model="form.titolo"
                >

                <span class="alert alert-danger"
                      v-if="errors.has('titolo')"
                      v-text="errors.get('titolo')">
                </span>
            </div>

            <div class="w-full modal-form-block">
                <label>
                    {{ trans.get('production.description' )}}:
                </label>
                <input type="text"
                       name="descrizione"
                       v-model="form.descrizione"
                >
                <span class="alert alert-danger"
                      v-if="errors.has('descrizione')"
                      v-text="errors.get('descrizione')">
                </span>
            </div>

            <div class="w-full flex">
                <div class="modal-form-block">
                    <label>
                        {{ trans.get('production.work_unit' )}}:
                    </label>
                    <div class="relative">
                        <select name="work_unit_id"
                                id="work_unit_id"
                                v-model="form.work_unit_id"
                        >
                            <option :value="workunit.id"
                                    v-for="workunit in workunits"
                                    v-text="workunit.id_reparto + ' | ' + workunit.descrizione"
                            >
                            </option>
                        </select>
                        <span class="alert alert-danger"
                              v-if="errors.has('work_unit_id')"
                              v-text="errors.get('work_unit_id')">
                        </span>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="modal-form-tag">
                    <label>
                        {{ trans.get('production.wu_int') }}:
                    </label>
                    <div>
                        <input-tag type="text"
                                   name="reparti_interessati"
                                   v-model="form.reparti_interessati"
                                   class="w-full"
                                   placeholder="Add a #tag"
                        >
                        </input-tag>
                    </div>
                    <span class="alert alert-danger"
                          v-if="errors.has('reparti_interessati')"
                          v-text="errors.get('reparti_interessati')"
                    >
                    </span>
                </div>
            </div>

            <div class="flex">
                <div class="modal-form-tag">
                    <label>
                        {{ trans.get('production.model' )}}:
                    </label>
                    <input-tag type="text"
                               name="modelli"
                               v-model="form.modelli"
                               class="w-full"
                               placeholder="Add a #tag"
                    >
                    </input-tag>
                    <span class="alert alert-danger"
                          v-if="errors.has('modelli')"
                          v-text="errors.get('modelli')">
                    </span>
                </div>
                <div class="modal-form-tag">
                    <label>
                        {{ trans.get('production.modifica_tecnica' )}}:
                    </label>
                    <div>
                        <input-tag class="w-full"
                                   type="text"
                                   name="mod_tech"
                                   v-model="form.mod_tech"
                                   placeholder="Add a #tag"
                        >
                        </input-tag>
                    </div>
                </div>
                <div class="modal-form-tag w-56">
                    <label>
                        {{ trans.get('production.pr_relate' )}}:
                    </label>
                    <div>
                        <input-tag class="w-full"
                                   type="text"
                                   name="project"
                                   v-model="form.project"
                                   placeholder="Add a #tag"
                        >
                        </input-tag>
                    </div>
                </div>
            </div>

            <div class="modal-form-block">
                <label>
                    {{ trans.get('production.upload' )}}:
                </label>
                <div>
                    <input type="file"
                           name="file"
                           id="file"
                           accept="application/pdf"
                           @change="onChange"
                    >
                    <span class="alert alert-danger"
                          v-if="errors.has('file')"
                          v-text="errors.get('file')">
                    </span>
                </div>
            </div>

            <div class="modal-form-block">
                <label>
                    {{ trans.get('production.url_video') }}:
                </label>
                <div>
                    <input type="url"
                           name="url_video"
                           id="url_video"
                           v-model="form.url_video"
                           class="w-full"
                    >
                </div>
            </div>

            <div class="flex justify-center p-6">
                <button type="submit"
                        class="btn is-aitems-700 px-12"
                        :class="loading ? 'loader' : ''"
                        :disabled="errors.any()"
                >
                    {{ trans.get('production.crea') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import DatePicker from "./DatePicker";
    import moment from 'moment';
    import Errors from "../utilities/Errors";
    import InputTag from "vue-input-tag";

    export default {

        components: {
            DatePicker,
            InputTag,
        },

        data() {
            return {
                form: {
                    codice: '',
                    titolo: '',
                    descrizione: '',
                    modelli: [],
                    mod_tech: [],
                    project: [],
                    work_unit_id: '',
                    reparti_interessati: [],
                    url_video: '',
                },
                data_immissione: moment().format('DD-MM-YYYY'),
                workunits: {},
                file: '',
                errors: new Errors(),
                taggable: ['reparti_interessati', 'modelli', 'mod_tech', 'project'],
                loading: false,
            }
        },

        created() {
            axios.get('/workunits')
                .then(({data}) => this.workunits = data);

        },

        methods: {
            onChange(e) {
                console.log(e);
                if (!e.target.files.length) return;
                this.file = e.target.files[0];
            },
            reverseDate() {
                return this.data_immissione.split('-').reverse().join('-');
            },

            onSubmit() {
                this.loading = true;

                let payload = new FormData();

                for (var key in this.form) {
                    payload.append(key, this.JSONize(key, this.form[key]));
                }

                payload.append('data_immissione', this.reverseDate());
                payload.append('file', this.file);

                axios.post('/instructions', payload)
                    .then(({data}) => {
                        swal.fire('Instruction Created!');
                        this.$emit('instruction-created', data);
                        window.location.href = "/instructions/";
                    })
                    .catch(error => {
                        console.log(error.response.data);
                        this.errors.record(error.response.data.errors);
                        this.loading = false;
                    });
            },

            JSONize(key, value) {
                if (this.taggable.indexOf(key) == -1) {
                    return value;
                }
                return JSON.stringify(value);
            },
        }
    }
</script>

<style lang="scss" scoped>

    .alert {

        @apply text-xs mt-1 capitalize;

    }

    .alert-danger {

        @apply text-red-400;

    }

</style>